import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RefreshIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RefreshIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M16.8822 12.9943C16.6888 12.9943 16.4954 12.9205 16.3478 12.7729C16.0526 12.4777 16.0526 11.9994 16.3478 11.7042L18.5291 9.52338C18.8243 9.22815 19.3026 9.22815 19.5978 9.52338L21.7786 11.7042C22.0738 11.9994 22.0738 12.4777 21.7786 12.7729C21.4833 13.0681 21.0051 13.0681 20.7098 12.7729L19.0634 11.1265L17.4165 12.7729C17.2689 12.9205 17.0755 12.9943 16.8822 12.9943Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.93657 14.6978C4.7363 14.6978 4.54391 14.6181 4.4022 14.4764L2.22142 12.2951C1.92619 11.9999 1.92619 11.5216 2.22142 11.2264C2.51666 10.9311 2.99493 10.9311 3.29017 11.2264L4.93658 12.8733L6.58299 11.2264C6.87822 10.9311 7.3565 10.9311 7.65173 11.2264C7.94697 11.5216 7.94697 11.9999 7.65173 12.2951L5.47095 14.4764C5.32925 14.6181 5.13683 14.6978 4.93657 14.6978Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 19.8845C10.1986 19.8845 8.50298 19.2931 7.09619 18.1742C6.76947 17.9144 6.71534 17.439 6.97515 17.1123C7.23495 16.7861 7.71175 16.7315 8.037 16.9913C9.17364 17.8952 10.544 18.3729 12 18.3729C15.5142 18.3729 18.3731 15.5141 18.3731 11.9999C18.3731 11.4847 18.3116 10.973 18.19 10.4784C18.0906 10.073 18.3386 9.66409 18.7441 9.56421C19.149 9.46481 19.5589 9.7128 19.6583 10.1183C19.8084 10.7304 19.8847 11.3636 19.8847 11.9999C19.8847 16.3476 16.3478 19.8845 12 19.8845Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.02858 14.2579C4.68021 14.2579 4.36677 14.0153 4.29051 13.6606C4.17439 13.1183 4.11533 12.5594 4.11533 11.9999C4.11533 7.65212 7.65222 4.11523 12 4.11523C13.9638 4.11523 15.8454 4.842 17.2984 6.16119C17.6079 6.44166 17.6306 6.91944 17.3501 7.22845C17.0696 7.53746 16.5908 7.56009 16.2828 7.28012C15.1083 6.21383 13.5874 5.62682 12 5.62682C8.48576 5.62682 5.62692 8.48565 5.62692 11.9999C5.62692 12.4531 5.67465 12.9053 5.76863 13.3437C5.85621 13.7516 5.59641 14.1536 5.18801 14.2412C5.13438 14.2525 5.08123 14.2579 5.02858 14.2579Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RefreshIcon;
